import React, { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { LIST_LEVEL } from '../../shared/constants'
import { filterJobAtom } from '../../shared/globalStates'
import CustomNativeSelect from './CustomNativeSelect'

function NativeSelectMasterLevel({ resetOnMount, resetOnUnmount }) {
    const [filter, setFilter] = useRecoilState(filterJobAtom)
    // console.log("filterjobatom", filterJobAtom);

    useEffect(() => {
        if (resetOnMount) {
            setFilter([]);
        }
        return () => {
            if (resetOnUnmount) {
                setFilter([]);
            }
        };
    }, [setFilter, resetOnMount, resetOnUnmount]);

    const handleChange = (e) => {
        // if (!filter.includes(e.target.value)) {
            // setFilter((prevData) => [...prevData, e.target.value]);
            // setFilter((prevData) => [e.target.value]);
            // console.log(e.target.value);
            // setFilter([e.target.value]);
            // setFilter(e.target.value);
            setFilter({ ...filter, level: e.target.value });
        // }
    };
    
    return (
        <CustomNativeSelect
            icon="stacked_line_chart"
            handleSelect={handleChange}
        >
            <option value="">
                Select job level
            </option>
            {
                LIST_LEVEL.map((level, index) => (
                    <option key={index} value={level}>{level}</option>
                ))
            }
        </CustomNativeSelect>
    )
}

export default NativeSelectMasterLevel